const app = {
  state: {
    device: ""
  },
  mutations: {
    // 设置设备
    SET_DEVICE: (state, newDevice) => {
      state.device = newDevice;
    }
  },
  actions: {
    SetDevice: (context, newDevice) => {
      context.commit("SET_DEVICE", newDevice);
    }
  }
};

export default app;
